import { Link } from "react-router-dom";
import Nav from "@/saas/components/Nav";
import { BRAND } from "@/saas/config/brand";

/**
 * Shared cinematic split auth layout: left = form panel, right = hero image.
 * Each page injects its own title/subtitle/fields via children.
 */
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-bg text-white">
      <Nav />
      <div className="min-h-screen grid lg:grid-cols-2">
        {/* ==== Form panel ==== */}
        <div className="flex items-center justify-center px-6 py-28 lg:py-24">
          <div className="w-full max-w-md">
            <div className="mb-10">
              <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter leading-[1.05] mb-3">
                {title}
              </h1>
              <p className="text-white/60">{subtitle}</p>
            </div>
            {children}
            {footer ? <div className="mt-8 pt-6 border-t border-white/10">{footer}</div> : null}
          </div>
        </div>

        {/* ==== Hero side (desktop only) ==== */}
        <aside className="relative hidden lg:block overflow-hidden">
          <img
            src="/images/auth-shell.jpg"
            alt=""
            className="w-full h-full object-cover opacity-70"
          />
          <div className="absolute inset-0 bg-gradient-to-l from-transparent via-black/40 to-bg" />
          <div className="absolute inset-0 noise" />
          <div className="absolute bottom-10 left-10 right-10 max-w-md">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-gold/40 bg-gold/10 mb-4">
              <span className="text-[10px] font-mono uppercase tracking-widest text-gold">{BRAND.logo.text}</span>
            </div>
            <p className="font-display text-3xl font-bold leading-tight text-shadow-strong">
              “{BRAND.tagline}”
            </p>
          </div>
        </aside>
      </div>
    </div>
  );
}

export function Field({ label, children, hint }) {
  return (
    <label className="block">
      <span className="block text-xs font-medium text-white/70 mb-1.5">{label}</span>
      {children}
      {hint ? <span className="block text-[11px] text-white/40 mt-1">{hint}</span> : null}
    </label>
  );
}

export function Input(props) {
  return (
    <input
      {...props}
      className={`w-full h-12 px-4 rounded-md bg-black/40 border border-white/10 text-white placeholder:text-white/30
        focus:border-gold focus:ring-2 focus:ring-gold/30 focus:outline-none transition ${props.className || ""}`}
    />
  );
}

export function AuthLink({ to, children }) {
  return (
    <Link to={to} className="text-gold hover:text-gold-hover font-semibold">{children}</Link>
  );
}
